module.exports = "/static/assets/f910811833cf5437c12d6feac526c62a.png";